import { useEffect, useState } from "react";
import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Image,
    InputGroup,
} from "@chakra-ui/react";
import {
    useDispatch,
    useSelector,
} from "react-redux";
import {
    Eye,
    EyeOff,
} from "lucide-react";
import {
    useNavigate,
} from "react-router-dom";

import {
    registerAction,
    checkEmailAction,
} from "../../../../state/actions/authActions";

import {
    toaster,
} from "../../../../components/toaster";

import ActivityToast from "../../../../components/ActivityToast";
import AppCheckbox from "../../../../components/AppCheckBox";

import routes from "../../../../routes";
import Logo from "../../../../assets/logo.png";

const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        email.trim()
    );
};
const isValidPhoneNumber = (phone) => {
    return /^\d{8}$/.test(phone);
};
const isValidUsername = (
    username
) => {
    return /^[A-Za-z0-9_]{3,15}$/.test(
        username.trim()
    );
};
const RegisterForm = () => {
    const dispatch =
        useDispatch();

    const navigate =
        useNavigate();

    const {
        loading,
        checkingEmail,
        emailAvailable,
        emailCheckError,
    } = useSelector(
        (state) =>
            state.auth
    );


    const [
        form,
        setForm,
    ] = useState({
        username: "",
        email: "",
        password: "",
        phone_number: "",
    });

    const [
        showPassword,
        setShowPassword,
    ] = useState(false);

    const [
        agreement,
        setAgreement,
    ] = useState(false);

        useEffect(() => {
    const email =
        form.email.trim();
    if (
        !email ||
        !isValidEmail(email)
    ) {
        return;
    }

    const timer =
        setTimeout(() => {
            dispatch(
                checkEmailAction(
                    email
                )
            );
        }, 600);

    return () =>
        clearTimeout(timer);
}, [
    form.email,
    dispatch,
]);

    const handleChange = (
        field,
        value
    ) => {
        setForm(
            (prev) => ({
                ...prev,
                [field]:
                    value,
            })
        );
    };

const isFormValid =
    isValidUsername(
        form.username
    ) &&
    form.email.trim() !== "" &&
    isValidEmail(form.email) &&
    form.password.trim() !== "" &&
    isValidPhoneNumber(
        form.phone_number
    ) &&
    form.phone_number.trim() !== "";

    const handleSubmit =
        async () => {
            const payload =
                {
                    username:
                        form.username,
                    email:
                        form.email,
                    password:
                        form.password,
                    phone_number: `+267${form.phone_number}`,
                    user_type:
                        "Driver Partner",
                    agreement_accepted:
                        true,
                };

            const result =
                await dispatch(
                    registerAction(
                        payload
                    )
                );

            if (
                result?.success
            ) {
                toaster.create(
                    {
                        render:
                            () => (
                                <ActivityToast
                                    type="success"
                                    title="Account Created"
                                    description="We've sent an OTP to your email address."
                                    timestamp="Just now"
                                />
                            ),
                    }
                );

                setTimeout(
                    () => {
                        navigate(
                            routes.verifyOtp,
                            {
                                state:
                                    {
                                        user_id:
                                            result
                                                .data
                                                ?.data
                                                ?.user_id,
                                        email:
                                            payload.email,
                                    },
                            }
                        );
                    },
                    1000
                );
            } else {
                toaster.create(
                    {
                        render:
                            () => (
                                <ActivityToast
                                    type="error"
                                    title="Registration Failed"
                                    description={
                                        result.error ||
                                        "Unable to create account."
                                    }
                                    timestamp="Just now"
                                />
                            ),
                    }
                );
            }
        };

    return (
        <Box
            p={{
                base: 6,
                md: 10,
                lg: 20,
            }}
        >
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize={{
                        base: "36px",
                        md: "48px",
                    }}
                    fontWeight="700"
                    color="#071D54"
                    mb={3}
                >
                    Become a
                    Partner
                </Text>

                <Text
                    color="gray.600"
                    maxW="420px"
                    mx="auto"
                >
                    Create your
                    account to start
                    recruiting
                    drivers,
                    tracking
                    milestones,
                    and earning
                    rewards.
                </Text>
            </Box>

            <VStack gap={5}>
                <Input
    size="lg"
    placeholder="Username"
    value={form.username}
    maxLength={15}
    onChange={(e) =>
        handleChange(
            "username",
            e.target.value
                .replace(/\s+/g, "_")
                .slice(0, 15)
        )
    }
/>

{form.username.trim() &&
    !isValidUsername(
        form.username
    ) && (
        <Text
            width="100%"
            color="red.500"
            fontSize="sm"
            mt={-3}
        >
            Use 3–15 characters: letters, numbers, or
    underscores. Example: John_Doe . Avoid Spaces
        </Text>
    )}

                <Input
    size="lg"
    type="email"
    placeholder="Email address"
    value={form.email}
    onChange={(e) =>
        handleChange(
            "email",
            e.target.value
        )
    }
/>

{form.email.trim() &&
    !isValidEmail(form.email) && (
        <Text
            width="100%"
            color="red.500"
            fontSize="sm"
            mt={-3}
        >
            Please enter a valid email address.
        </Text>
    )}

{form.email.trim() &&
    isValidEmail(form.email) &&
    checkingEmail && (
        <Text
            width="100%"
            color="gray.500"
            fontSize="sm"
            mt={-3}
        >
            Checking if this email is already registered on the Mogoma App...
        </Text>
    )}

{form.email.trim() &&
    isValidEmail(form.email) &&
    !checkingEmail &&
    emailAvailable === true && (
        <Text
            width="100%"
            color="green.600"
            fontSize="sm"
            mt={-3}
            
        >
               ✓ This email is not registered on the Mogoma App and can be used for your Driver Partner account.
        </Text>
    )}

{form.email.trim() &&
    isValidEmail(form.email) &&
    !checkingEmail &&
    emailAvailable === false && (
        <Text
            width="100%"
            color="red.500"
            fontSize="sm"
            mt={-3}
        >
            This email address is already registered
            on the Mogoma App. Please use a different
            email address if you are registering as a
            Driver Partner.
        </Text>
    )}

               <InputGroup>
    <Input
        size="lg"
        placeholder="Phone number"
        value={form.phone_number}
        onChange={(e) =>
            handleChange(
                "phone_number",
                e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 8)
            )
        }
        maxLength={8}
    />
</InputGroup>

{form.phone_number.trim() &&
    !isValidPhoneNumber(form.phone_number) && (
        <Text
            width="100%"
            color="red.500"
            fontSize="sm"
            mt={-3}
        >
            Phone number must contain exactly 8 digits.
        </Text>
    )}

                <InputGroup
                    endElement={
                        showPassword ? (
                            <EyeOff
                                size={
                                    18
                                }
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(
                                        false
                                    )
                                }
                            />
                        ) : (
                            <Eye
                                size={
                                    18
                                }
                                cursor="pointer"
                                onClick={() =>
                                    setShowPassword(
                                        true
                                    )
                                }
                            />
                        )
                    }
                >
                    <Input
                        size="lg"
                        placeholder="Password"
                        type={
                            showPassword
                                ? "text"
                                : "password"
                        }
                        value={
                            form.password
                        }
                        onChange={(
                            e
                        ) =>
                            handleChange(
                                "password",
                                e.target
                                    .value
                            )
                        }
                    />
                </InputGroup>

                <AppCheckbox
    checked={
        agreement
    }
    onCheckedChange={(
        e
    ) =>
        setAgreement(
            e.checked
        )
    }
>
    <Text
        fontSize="sm"
        color="gray.600"
    >
        I agree to the
        {" "}
        <Text
            as="span"
            color="#2453FF"
            fontWeight="600"
            cursor="pointer"
            _hover={{
                textDecoration:
                    "underline",
            }}
            onClick={(
                e
            ) => {
                e.stopPropagation();
                navigate(
                    routes.terms
                );
            }}
        >
            Terms &
            Conditions
        </Text>
        {" "}
        and
        {" "}
        <Text
            as="span"
            color="#2453FF"
            fontWeight="600"
            cursor="pointer"
            _hover={{
                textDecoration:
                    "underline",
            }}
            onClick={(
                e
            ) => {
                e.stopPropagation();
                navigate(
                    routes.privacy
                );
            }}
        >
            Privacy
            Policy
        </Text>
        .
    </Text>
</AppCheckbox>

                <Button
                    w="100%"
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    _hover={{
                        bg: "#1E46D8",
                    }}
                    disabled={
                        !isFormValid ||
                        !agreement ||
                        loading
                    }
                    loading={
                        loading
                    }
                    loadingText="Creating Account..."
                    opacity={
                        !isFormValid ||
                        !agreement
                            ? 0.6
                            : 1
                    }
                    onClick={
                        handleSubmit
                    }
                >
                    Create
                    Account
                </Button>
            </VStack>

            <Text
                mt={10}
                textAlign="center"
                color="gray.500"
                fontSize="sm"
            >
                Already have
                an account?{" "}
                <Text
                    as="span"
                    color="#2453FF"
                    fontWeight="600"
                    cursor="pointer"
                    onClick={() =>
                        navigate(
                            routes.login
                        )
                    }
                    _hover={{
                        textDecoration:
                            "underline",
                    }}
                >
                    Sign In
                </Text>
            </Text>
        </Box>
    );
};
export default RegisterForm;